import React from 'react';
import { Tooltip } from 'antd';
import { useGraphicStandMutation } from '../hooks';
import { Localize } from 'components/service';
import Icons from 'components/icons';



const GraphicStandStatusField = ({ graphicStand, graphicListId, variables }) => {

    if (!graphicStand)
    {
        return <strong>&mdash;</strong>;
    }


    const {
        update,
    } = useGraphicStandMutation.createUpdate({
        graphicStandId: graphicStand?.id,
        graphicListId,
        variables,
    });

    const handleStatusClick = () => {

        let nextStatus;
        switch (graphicStand?.status)
        {
            case 'open':
                nextStatus = 'done';
                break;
            case 'done':
                nextStatus = 'open';
                break;
            default:
                nextStatus = 'open';
        }

        update({
            variables: {
                input: {
                    id: graphicStand?.id ? +graphicStand?.id : undefined,
                    graphic_list_id: graphicListId,
                    status: nextStatus,
                }
            }
        });
    };

    const getTooltipText = () => {
        switch (graphicStand?.status)
        {
            case 'open':
                return <Localize>ACTIONS.List_Item_Label_Open</Localize>;
            case 'done':
                return <Localize>ACTIONS.List_Item_Label_Sent</Localize>;
            default:
                return <Localize>ACTIONS.List_Item_Label_Open</Localize>;
        }
    };


    const tooltipText = getTooltipText();


    return (
        <div className='graphic-craft-holder' style={ { display: 'inline-block', padding: '5px' } }>
            <Tooltip
                overlayClassName="craft-tooltip"
                destroyTooltipOnHide={ true }
                title={ tooltipText }
            >
                <span
                    className={ `craft ${ graphicStand?.status === 'open' ? 'color-white' : 'color-green' }` }
                    onClick={ handleStatusClick }
                >

                    <Icons.DeliveryTruck />

                </span>
            </Tooltip>
        </div>
    );
};

export default GraphicStandStatusField;